import { useEffect, useState } from 'react'

import { faBriefcase } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Loader from 'react-loaders'

import AnimatedLetters from '../AnimatedLetters'
import './index.scss'

const workExperience = [
  {
    id: 1,
    company: 'Almabrook',
    companyUrl: 'https://almabrook.com/',
    position: 'Blockchain Architect',
    duration: 'Aug 2025 – Present',
    location: 'Remote',
    achievements: [
      'Designed end-to-end architecture for a Real-World Asset (RWA) ecosystem including MPC custody, regulated exchange, and secondary marketplace.',
      'Led technical design for secure wallet infrastructure using MPC-based key management, policy controls, and institutional-grade transaction workflows.',
      'Architected compliant trading flows across Issuer/Investor/Backoffice roles with governance controls and audit-grade traceability.',
      'Defined Shariah-compliant and AAOIFI-aligned architecture, translating compliance requirements into enforceable system rules and product workflows.',
      'Designed secure integrations for KYC/AML, asset tokenization lifecycle, custody operations, and settlement workflows across on-chain + off-chain components.',
      'Owned scalability, reliability, and security strategy including service boundaries, data architecture, and production deployment standards.'
    ]
  },
  {
    id: 2,
    company: 'Funavry Technologies',
    companyUrl: 'https://funavry.com/',
    position: 'Blockchain Architect',
    duration: 'Aug 2025 – Present',
    location: 'Remote',
    achievements: [
      'Working as Blockchain Architect for two major clients of Funavry.',
      'Designing an on-chain AI inference blockchain using Cosmos.',
      'Designing a secure MPC-based Shariah-compliant architecture for RWA.',
      'Managing and training multiple teams of young developers in JavaScript and blockchain frameworks.'
    ]
  },
  {
    id: 3,
    company: 'Telos Labs',
    companyUrl: 'https://teloslabs.biz/',
    position: 'Head of Engineering (Web3)',
    duration: 'Feb 2022 – July 2025',
    location: 'Remote',
    achievements: [
      'Led blockchain department as Head of Engineering, designing new products and tools for the Web3 space in Avocado.',
      'Developed smart contracts in Solidity for Soulbound NFTs and staking pools.',
      'Configured and maintained Ethereum PoS validators.'
    ]
  },
  {
    id: 4,
    company: 'Optimus Fox',
    companyUrl: 'https://optimusfox.com/',
    position: 'Senior Software Engineer',
    duration: 'Dec 2020 – Feb 2022',
    location: 'Remote',
    achievements: [
      'Managed a blockchain team of 15 developers as Blockchain Team Lead.',
      'Designed Hyperledger Fabric v2.2 architecture.',
      'Wrote chaincode in JavaScript and Node.js for API connections to Hyperledger Fabric.'
    ]
  },
  {
    id: 5,
    company: 'DevProvider',
    companyUrl: 'https://devprovider.com/',
    position: 'Software Engineer',
    duration: 'Aug 2018 – Nov 2020',
    location: 'Remote',
    achievements: [
      'Developed a blockchain-based affiliate marketing platform.',
      'Designed blockchain solution in Hyperledger Composer v0.20 and Hyperledger Fabric v2.2.',
      'Wrote chaincode in Go and used Node.js SDK for API connections to Hyperledger Fabric.',
      'Modeled data structures using Hyperledger Modeling Language.'
    ]
  },
  {
    id: 6,
    company: 'NADRA',
    companyUrl: 'https://www.nadra.gov.pk/',
    position: 'Intern (Research and Development)',
    duration: 'June 2013 – Aug 2013',
    location: 'Pakistan',
    achievements: [
      'Worked in the R&D department of NADRA.',
      'Developed desktop solutions using C# and Oracle Database.'
    ]
  }
]

const Experience = () => {
  const experienceArray = 'Experience'.split('')
  const [letterClass, setLetterClass] = useState('text-animate')

  useEffect(() => {
    const timer = setTimeout(() => {
      setLetterClass('text-animate-hover')
    }, 2000)
    return () => clearTimeout(timer)
  }, [])

  return (
    <>
      <div className="container experience-page">
        <div className="text-zone">
          <h1>
            <AnimatedLetters
              letterClass={letterClass}
              strArray={experienceArray}
              idx={15}
            />
          </h1>
          <p>
            My professional journey spans across Web3, blockchain architecture,
            smart contracts, and distributed systems. From R&D at NADRA to
            leading engineering teams at Telos Labs and architecting RWA
            ecosystems at Almabrook, each role has contributed to my growth
            as a blockchain architect and technical leader.
          </p>
        </div>

        <div className="experience-container">
          <div className="timeline">
            {workExperience.map((job, index) => (
              <div key={job.id} className={`timeline-item ${index % 2 === 0 ? 'left' : 'right'}`}>
                <div className="timeline-marker">
                  <FontAwesomeIcon icon={faBriefcase} />
                </div>
                <div className="timeline-content">
                  <div className="job-header">
                    <h3 className="company-name">
                      <a href={job.companyUrl} target="_blank" rel="noreferrer">
                        {job.company}
                      </a>
                    </h3>
                    <h4 className="position">{job.position}</h4>
                    <div className="job-meta">
                      <span className="duration">{job.duration}</span>
                      <span className="location">{job.location}</span>
                    </div>
                  </div>
                  <ul className="achievements">
                    {job.achievements.map((achievement, idx) => (
                      <li key={idx}>{achievement}</li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <Loader type="pacman" />
    </>
  )
}

export default Experience
